import React from 'react';
import { showSnackbar } from '@lyearn-team/frontend-components/dist/showSnackbar/showSnackbar';
import ConditionalLoader from '../ConditionalLoader';
import useExternalScript from './useExternalScript';

function ScriptLoader({ src, id, errorMsg = 'Failed to load script', children }) {
  const { loading, error } = useExternalScript(src, id);

  if (error) {
    showSnackbar({
      label: errorMsg,
      status: 'error'
    });
  }

  return <ConditionalLoader loading={loading}>{children}</ConditionalLoader>;
}

export const withExternalScript = scriptLoaderProps => WrappedComponent => props => (
  <ScriptLoader {...scriptLoaderProps}>
    <WrappedComponent {...props} />
  </ScriptLoader>
);

export default ScriptLoader;
